export class Workstation {
  public workstationId: number;
  public companyId: number;
  public name: string;
  public os: string;
  public publicIP: string;
}
